import React from "react";
import WallCards from "./WallCards";
import LoadingScreen from "../../../../CommonComponents/LoadingScreen";

function Widget_Walls(props) {

  const { wallReducer, userData } = props

  return (
    <>
      <div className="row">
        {!wallReducer.wallRequest ? (
          wallReducer.widgetWallsData && wallReducer.widgetWallsData.length > 0 ? (
            wallReducer.widgetWallsData.map((item, index) => (
              <WallCards
                key={index}
                wallsData={item}
                clickToUpdateState={props.clickToUpdateState}
                index={index}
                userData={userData}
              />
            ))
          ) : <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-3">
            <div className="d-flex justify-content-center w-100 card card-custom card-stretch wall_card ">
              <button type="button" className="d-flex flex-wrap flex-column align-content-center add_card_button create-new-wall cursor-pointer px-5 w-100 btn" onClick={props.clickToUpdateState({ modalShow: true, wall_id: null, autoUpdate: 1, })}>
                <div className="">
                  <div className="add_wall_icon">
                    <span className="svg-icon f-center bg-light rounded-circle w-100 h-100"><i className="fa-regular fa-plus fs-2"></i>  </span>
                  </div><h5 class="text-center mt-3 mb-0"><span class="add_wall_card_txt popUp hide-on-desktop createWallbtn">Create Wall</span></h5></div>
              </button>
            </div>
          </div>
        ) : (
          <LoadingScreen />
        )}
      </div>
    </>
  );
}

export default Widget_Walls;
